// import Course from '@/page/Course.vue'
const Reportreadpaper = resolve =>require(['@/components/reportlibrary/Reportreadpaper.vue'], resolve)

export default {
	path: '/home/reportlibraryview/readpaper',
	component: Reportreadpaper,
	meta:{
		title: '阅卷',
		path:'/home/reportlibrary/0'
	}
}



// WEBPACK FOOTER //
// ./src/router/reportreadpaper.js